"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _i18n = require("../../utils/i18n");

var FileExtensionIsNotSupportedError =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FileExtensionIsNotSupportedError, _Component);

  function FileExtensionIsNotSupportedError() {
    (0, _classCallCheck2.default)(this, FileExtensionIsNotSupportedError);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileExtensionIsNotSupportedError).apply(this, arguments));
  }

  (0, _createClass2.default)(FileExtensionIsNotSupportedError, [{
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          fileExtension = _this$props.fileExtension,
          filter = _this$props.filter;
      var reasons = filter.get('reasons');

      if (reasons.has(fileExtension)) {
        return _react.default.createElement("span", null, reasons.get(fileExtension));
      }

      return _react.default.createElement(_FormattedMessage.default, {
        message: (0, _i18n.getFileFilteringErrorMessageKey)(filter.get('filterType')),
        options: (0, _i18n.getFileFilteringErrorMessageOptions)(filter.get('extensions'))
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "m-bottom-2"
      }, this.renderContent());
    }
  }]);
  return FileExtensionIsNotSupportedError;
}(_react.Component);

exports.default = FileExtensionIsNotSupportedError;
FileExtensionIsNotSupportedError.propTypes = {
  fileExtension: _react.PropTypes.string.isRequired,
  filter: _react.PropTypes.instanceOf(_immutable.Map).isRequired
};
module.exports = exports.default;